import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { useAppSelector } from 'redux/hooks/reduxHooks';
import { selectSpecialPage } from 'redux/selectors/selectors';
import { TCardType, ECardTypes } from 'shared/types/card.interface';
import { IChallangeData } from 'shared/types/challenges.interface';
import { EDebateStatuses, IDebateData } from 'shared/types/debates.interface';
import { cardStatuses } from '../card.statuses';

type CardStatusProps = {
  type: TCardType;
  cardInfo: IChallangeData;
  debate?: IDebateData;
  fullCard?: boolean;
};

export const CardStatus: React.FC<CardStatusProps> = ({ type, cardInfo, debate, fullCard }) => {
  const specialPage = useAppSelector(selectSpecialPage);

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      columnGap="5px"
      sx={{
        backgroundColor:
          type === ECardTypes.Challenge
            ? cardStatuses[type][cardInfo.status]?.backgroundColor
            : cardStatuses[type][debate?.status]?.backgroundColor,
        borderRadius: '8px',
        padding: { lg: '8px 12px', md: '7px 12px', sm: '7px 12px', xs: '7px 12px' },
        maxHeight: { lg: '40px', md: '32px', sm: '32px', xs: '32px' },
      }}
    >
      {debate?.status === EDebateStatuses.InProgress && !specialPage && (
        <Box
          sx={{
            borderRadius: '50%',
            width: '14px',
            height: '14px',
            background: (theme) => theme.palette.error.main,
            '@keyframes scaling': {
              '0%': {
                transform: 'scale(0.85)',
                opacity: 0.9,
              },
              '50%': {
                transform: 'scale(1)',
                opacity: 1,
              },
              '100%': {
                transform: 'scale(0.85)',
                opacity: 0.9,
              },
            },
            animation: '2s linear 1s scaling infinite',
          }}
        />
      )}
      <Typography
        color={
          type === ECardTypes.Challenge
            ? cardStatuses[type][cardInfo.status]?.textColor
            : cardStatuses[type][debate?.status]?.textColor
        }
        variant="h4"
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        sx={{
          fontSize: { lg: fullCard ? 20 : 14, md: 14, sm: 14, xs: 14 },
        }}
      >
        {type === ECardTypes.Challenge
          ? cardStatuses[type][cardInfo.status]?.text
          : cardStatuses[type][debate?.status]?.text}
      </Typography>
    </Stack>
  );
};
